export const CartActionType = {
    SelectedCart: '[Cart] Selected Cart',
};